import { CommonInputProps, useInput } from "react-admin";
import { Autocomplete, Chip, TextField } from "@mui/material";

export function ChipsInput(props: CommonInputProps & { label: string; knownValues: Array<string> }) {
  const { label, knownValues } = props;
  const {
    field,
    fieldState: { isTouched, invalid, error },
    formState: { isSubmitted },
    isRequired,
  } = useInput({ defaultValue: [], ...props });

  const { value, onChange } = field;
  if (value && !Array.isArray(value)) {
    throw new Error(`ChipsInput requires an array value but received: ${JSON.stringify(value)}`);
  }

  const showError = (isTouched || isSubmitted) && invalid;

  return (
    <Autocomplete
      multiple
      freeSolo
      options={knownValues}
      value={value ?? []}
      onChange={(_event, newValue) => onChange(newValue)}
      renderTags={(tagValue, getTagProps) =>
        tagValue.map((option, index) => {
          const { key, ...tagProps } = getTagProps({ index });
          return <Chip label={option} key={key} {...tagProps} />;
        })
      }
      renderInput={(params) => (
        <TextField
          {...params}
          label={isRequired ? label + "*" : label}
          fullWidth={props.fullWidth}
          error={showError}
          helperText={showError ? error?.message : undefined}
        />
      )}
    />
  );
}
